// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  pending: null,
  picklists: null,
  picklistItems: null,
  readyForPickup: null,
  errorMessage: null,
  successMessage: null,
  printPicklistItems: null,
  isLoading: false,
  isPrinted: false,
  isCreatingPicklist: false,
  isMovingtoRFP: false,
  isUpdatedPicklist: false,
  isCreatedPicklist: false,
  isMovedtoRFP: false,
  isMarkingOutOfStock: false,
  isMarkedOutOfStock: false
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get requests */
export const getRequests = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: true,
    isUpdatedPicklist: false,
    isCreatedPicklist: false,
    isMovedtoRFP: false
  };
};

export const getRequestsSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  pending: action.pending,
  isLoading: false
});

export const getRequestsFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* getPicklists */
export const getPicklists = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: true,
    isUpdatedPicklist: false,
    isCreatedPicklist: false,
    isMovedtoRFP: false
  };
};

export const getPicklistsSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  picklists: action.picklists,
  isLoading: false
});

export const getPicklistsFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* getPicklistItems */
export const getPicklistItems = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading:
      action.query.indexOf("is_export") === -1 &&
      action.query.indexOf("print") === -1,
    isUpdatedPicklist: false,
    isCreatedPicklist: false,
    isMovedtoRFP: false,
    isPrinted: false,
    printPicklistItems: null,
    isExporting: action.query.indexOf("is_export") !== -1,
    isPrinting: action.query.indexOf("print") !== -1
  };
};

export const getPicklistItemsSuccess = (state = INITIAL_STATE, action) => {
  const val = {
    ...state,
    isLoading: false,
    isExporting: false
  };
  if (!state.isExporting) {
    if (state.isPrinting) {
      val.printPicklistItems = action.picklistItems;
      val.isPrinted = true;
    } else val.picklistItems = action.picklistItems;
  }
  return val;
};

export const getPicklistItemsFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  isExporting: false,
  isPrinted: false,
  errorMessage: action.error || genericError
});

/* getReadyForPickup */
export const getReadyForPickup = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: true,
    isUpdatedPicklist: false,
    isCreatedPicklist: false,
    isMovedtoRFP: false
  };
};

export const getReadyForPickupSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  readyForPickup: action.readyForPickup,
  isLoading: false
});

export const getReadyForPickupFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* getStocksCount */
export const getStocksCount = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isCounting: true
  };
};

export const getStocksCountSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  stocksCount: action.stocksCount,
  isCounting: false
});

export const getStocksCountFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isCounting: false,
  errorMessage: action.error || genericError
});

/* createPicklist */
export const createPicklist = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isCreatingPicklist: true,
    isCreatedPicklist: false,
    isUpdatedPicklist: false,
    isMovedtoRFP: false
  };
};

export const createPicklistSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  isCreatingPicklist: false,
  isCreatedPicklist: true
});

export const createPicklistFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isCreatingPicklist: false,
  isCreatedPicklist: false,
  errorMessage: action.error || genericError
});

/* updatePicklistQty */
export const updatePicklistQty = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isUpdatingPicklist: true,
    isUpdatedPicklist: false,
    isCreatedPicklist: false,
    isMovedtoRFP: false
  };
};

export const updatePicklistQtySuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  isUpdatingPicklist: false,
  isUpdatedPicklist: true
});

export const updatePicklistQtyFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isUpdatingPicklist: false,
  isUpdatedPicklist: false,
  errorMessage: action.error || genericError
});

/* markReadyForPickup */
export const markReadyForPickup = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isMovingtoRFP: true,
    isMovedtoRFP: false
  };
};

export const markReadyForPickupSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  isMovingtoRFP: false,
  isMovedtoRFP: true
});

export const markReadyForPickupFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isMovingtoRFP: false,
  isMovedtoRFP: false,
  errorMessage: action.error || genericError
});

/* markOutOfStock */
export const markOutOfStock = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isMarkingOutOfStock: true,
    isMarkedOutOfStock: false,
    isUpdatedPicklist: false,
    isCreatedPicklist: false,
    isMovedtoRFP: false
  };
};

export const markOutOfStockSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isMarkingOutOfStock: false,
    isMarkedOutOfStock: true
  };
};

export const markOutOfStockFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isMarkingOutOfStock: false,
  isMarkedOutOfStock: false,
  errorMessage: action.error || genericError
});

const ACTION_HANDLERS = {
  [Types.GET_REQUESTS]: getRequests,
  [Types.GET_REQUESTS_SUCCESS]: getRequestsSuccess,
  [Types.GET_REQUESTS_FAILURE]: getRequestsFailure,
  [Types.CREATE_PICKLIST]: createPicklist,
  [Types.CREATE_PICKLIST_SUCCESS]: createPicklistSuccess,
  [Types.CREATE_PICKLIST_FAILURE]: createPicklistFailure,
  [Types.GET_PICKLISTS]: getPicklists,
  [Types.GET_PICKLISTS_SUCCESS]: getPicklistsSuccess,
  [Types.GET_PICKLISTS_FAILURE]: getPicklistsFailure,
  [Types.GET_PICKLIST_ITEMS]: getPicklistItems,
  [Types.GET_PICKLIST_ITEMS_SUCCESS]: getPicklistItemsSuccess,
  [Types.GET_PICKLIST_ITEMS_FAILURE]: getPicklistItemsFailure,
  [Types.MARK_READY_FOR_PICKUP]: markReadyForPickup,
  [Types.MARK_READY_FOR_PICKUP_SUCCESS]: markReadyForPickupSuccess,
  [Types.MARK_READY_FOR_PICKUP_FAILURE]: markReadyForPickupFailure,
  [Types.GET_READY_FOR_PICKUP]: getReadyForPickup,
  [Types.GET_READY_FOR_PICKUP_SUCCESS]: getReadyForPickupSuccess,
  [Types.GET_READY_FOR_PICKUP_FAILURE]: getReadyForPickupFailure,
  [Types.UPDATE_PICKLIST_QTY]: updatePicklistQty,
  [Types.UPDATE_PICKLIST_QTY_SUCCESS]: updatePicklistQtySuccess,
  [Types.UPDATE_PICKLIST_QTY_FAILURE]: updatePicklistQtyFailure,
  [Types.GET_STOCKS_COUNT]: getStocksCount,
  [Types.GET_STOCKS_COUNT_SUCCESS]: getStocksCountSuccess,
  [Types.GET_STOCKS_COUNT_FAILURE]: getStocksCountFailure,
  [Types.MARK_OUT_OF_STOCK]: markOutOfStock,
  [Types.MARK_OUT_OF_STOCK_SUCCESS]: markOutOfStockSuccess,
  [Types.MARK_OUT_OF_STOCK_FAILURE]: markOutOfStockFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/StockRequestReducer.js